"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignersClient = void 0;
const fetch_1 = require("../../utils/fetch");
const url_1 = require("../../utils/url");
class SignersClient {
    constructor(apiOptions) {
        this.apiOptions = apiOptions;
    }
    async listSigners() {
        const path = (0, url_1.buildPathAndQuery)('/signers', {
            path: {},
            query: {},
        });
        const response = await (0, fetch_1.simpleFetch)(path, {
            method: 'GET',
            apiOptions: this.apiOptions,
        });
        return response.json();
    }
}
exports.SignersClient = SignersClient;
